// extracted by mini-css-extract-plugin
export default {"imageWrapper":"SM-z","twoColumnImage":"TM-z"};